import { Component, ViewEncapsulation } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastNotificationService } from '../core/toast-notification.service';
import { MemberAdService } from '../member-ads/member-ad.service';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ConfirmModalComponent {

    constructor(private activeModal: NgbActiveModal) { }

    dismiss(): void {
        this.activeModal.dismiss();
    }
    close(): void {
        this.activeModal.close();
    }
}
